import apiFetch from '@wordpress/api-fetch';
import { toast } from 'sonner-vanilla';

interface ProfileResponse {
	message: string;
}

export function initProfile(): void {
	const readCard = document.getElementById('ac-profile-read');
	const editForm = document.getElementById(
		'ac-profile-form',
	) as HTMLFormElement | null;
	const editBtn = document.getElementById('ac-profile-edit-btn');
	const cancelBtn = document.getElementById('ac-profile-cancel-btn');

	if (!readCard || !editForm || !editBtn) return;

	const showEdit = () => {
		readCard.style.display = 'none';
		editForm.style.display = 'block';
	};

	const showRead = () => {
		editForm.style.display = 'none';
		readCard.style.display = 'block';
	};

	editBtn.addEventListener('click', showEdit);
	cancelBtn?.addEventListener('click', showRead);

	editForm.addEventListener('submit', async (ev) => {
		ev.preventDefault();

		const firstName = (
			editForm.querySelector('[name="first_name"]') as HTMLInputElement
		).value;
		const lastName = (
			editForm.querySelector('[name="last_name"]') as HTMLInputElement
		).value;
		const email = (editForm.querySelector('[name="email"]') as HTMLInputElement)
			.value;
		const phone = (editForm.querySelector('[name="phone"]') as HTMLInputElement)
			.value;
		const timezone = (
			editForm.querySelector('[name="timezone"]') as HTMLSelectElement
		).value;

		const submitBtn =
			editForm.querySelector<HTMLButtonElement>('[type="submit"]');
		if (submitBtn) {
			submitBtn.disabled = true;
			submitBtn.classList.add('ac-btn--loading');
		}

		try {
			const res = await apiFetch<ProfileResponse>({
				path: 'allcoach/v1/client/update-profile',
				method: 'POST',
				data: {
					first_name: firstName,
					last_name: lastName,
					email,
					phone,
					timezone,
				},
			});

			toast.success(res.message || 'Profile updated successfully.');

			const field = (name: string, value: string) => {
				const el = readCard.querySelector(`[data-field="${name}"]`);
				if (el) el.textContent = value || '-';
			};
			field('first_name', firstName);
			field('last_name', lastName);
			field('email', email);
			field('phone', phone);
			field('timezone', timezone);

			showRead();
		} catch (err) {
			const message =
				(err as { message?: string })?.message || 'Something went wrong.';
			toast.error(message);
		} finally {
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.classList.remove('ac-btn--loading');
			}
		}
	});
}
